export default __webpack_public_path__ + "static/media/background-9.947b28be.jpg";